import { apiRequest } from "./client";

/**
 * NestJS invoices contract (Part 97):
 * - GET    /api/invoices?status=&contactId=&q=&page=&size= → { items, total, page, size }
 * - POST   /api/invoices   → invoice (auto INV-#### number)
 * - GET    /api/invoices/:id
 * - PATCH  /api/invoices/:id   (status lifecycle: draft → sent → paid / cancelled)
 * - DELETE /api/invoices/:id   (Owner/Manager)
 */
const LIST_SIZE = 200;

export const invoicesApi = {
  getAll: async ({ status = "all", contactId, q } = {}) => {
    const params = new URLSearchParams({ page: "1", size: String(LIST_SIZE) });
    if (status && status !== "all") params.set("status", status);
    if (contactId) params.set("contactId", contactId);
    if (q?.trim()) params.set("q", q.trim());
    const data = await apiRequest(`/api/invoices?${params}`);
    return data?.items || [];
  },

  create: (payload) => apiRequest("/api/invoices", { method: "POST", body: JSON.stringify(payload) }),

  update: (id, payload) => apiRequest(`/api/invoices/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),

  remove: (id) => apiRequest(`/api/invoices/${id}`, { method: "DELETE" }),
};